var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"v-resume-link",class:[
		{ 'v-resume-link--large': _vm.large }
	],attrs:{"href":_vm.url,"target":_vm.target,"rel":_vm.rel}},[_c('span',{ref:"vresume_link"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }